import { render, staticRenderFns } from "./prix copy.vue?vue&type=template&id=d4621e78&scoped=true&"
import script from "./prix copy.vue?vue&type=script&lang=js&"
export * from "./prix copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4621e78",
  null
  
)

export default component.exports